import React from 'react';
import { DISPLAY_STYLE, } from '../../types';
import * as Styled from './Leaflet.styles';
import { TableContainer, Paper, TableBody, Table } from '@mui/material';
export const RealValueVisualization = ({ metadata: { realTimeData }, }) => {
    const getColors = (sensor) => {
        let bg = '';
        if (sensor.value) {
            if (sensor.highhigh?.value !== undefined &&
                sensor.value >= sensor.highhigh.value) {
                bg = sensor.highhigh?.color || '';
            }
            else if (sensor.lowlow?.value !== undefined &&
                sensor.value <= sensor.lowlow.value) {
                bg = sensor.lowlow?.color || '';
            }
            else if (sensor.lowlow?.value !== undefined &&
                sensor.low?.value !== undefined &&
                sensor.value > sensor.lowlow.value &&
                sensor.value <= sensor.low.value) {
                bg = sensor.low?.color || '';
            }
            else if (sensor.highhigh?.value !== undefined &&
                sensor.high?.value !== undefined &&
                sensor.value < sensor.highhigh.value &&
                sensor.value >= sensor.high.value) {
                bg = sensor.high?.color || '';
            }
        }
        const text = bg
            ? pickTextColorBasedOnBgColor(bg, 'white', 'black')
            : '';
        return {
            bg,
            text,
        };
    };
    function pickTextColorBasedOnBgColor(bgColor, lightColor, darkColor) {
        const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16); // hexToR
        const g = parseInt(color.substring(2, 4), 16); // hexToG
        const b = parseInt(color.substring(4, 6), 16); // hexToB
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
    }
    if (realTimeData) {
        return (React.createElement(Styled.InlineBox, { display: realTimeData.displayStyle }, realTimeData.displayStyle === DISPLAY_STYLE.STACKED ? (React.createElement(React.Fragment, null,
            realTimeData.title && (React.createElement(Styled.SensorContent, { isTitle: true, display: realTimeData.displayStyle }, realTimeData.title)),
            React.createElement(TableContainer, { component: Paper, style: { overflowX: 'initial' } },
                React.createElement(Table, { size: "small" },
                    React.createElement(TableBody, null, realTimeData.sensors.map(sensor => (React.createElement(Styled.CustomTableRow, { colors: getColors(sensor), key: sensor.id, sx: {
                            '&:last-child td, &:last-child th': {
                                border: 0,
                            },
                        } },
                        React.createElement(Styled.CustomTableCell, { component: "th", scope: "row", "data-title": sensor.valueTimestamp }, sensor.name),
                        React.createElement(Styled.CustomTableCell, { align: "right", "data-title": sensor.valueTimestamp }, sensor.value !== undefined &&
                            sensor.value.toFixed(sensor.decimalPlaces)),
                        React.createElement(Styled.CustomTableCell, { align: "left", "data-title": sensor.valueTimestamp }, sensor.isShowUnit &&
                            sensor.value !==
                                undefined &&
                            sensor.unit))))))))) : (realTimeData.sensors.map(sensor => (React.createElement(Styled.SensorContent, { display: realTimeData.displayStyle, colors: getColors(sensor), key: sensor.id, "data-title": sensor.valueTimestamp, draggable: true, id: sensor.id },
            realTimeData.title && (React.createElement(Styled.Title, null, realTimeData.title)),
            React.createElement(Styled.SensorContentData, null,
                sensor.name && React.createElement("span", null, sensor.name),
                sensor.value !== undefined && (React.createElement(React.Fragment, null,
                    React.createElement("span", null, sensor.value.toFixed(sensor.decimalPlaces)),
                    sensor.isShowUnit && sensor.unit && (React.createElement("span", null, sensor.unit)))))))))));
    }
    return React.createElement(React.Fragment, null);
};
